export default class Service {

    host: string;
    contentType: string;
    customHeaders: {};

    constructor(host: string, customHeaders: {} = {}, contentType: string = "application/json") {
        this.host = host;
        this.contentType = contentType;
        this.customHeaders = customHeaders;

        this.customHeaders["Content-Type"] = this.contentType;

        this.customHeaders = {
            "api-key": customHeaders["api-key"],
            "Content-Type": this.contentType
        };
    }

    async get<T>(url: string): Promise<T> {
        let response = await fetch(this.host + url, { credentials: "same-origin" });
        var body = await response.json();

        if (response.ok) {
            return body;
        }

        return Promise.reject(body);
    }

    put<TRequest, TResponse>(url: string, data: TRequest): Promise<TResponse> {
        return this.postput(url, data, "PUT");
    }

    post<TRequest, TResponse>(url: string, data: TRequest): Promise<TResponse> {
        return this.postput(url, data, "POST");
    }

    patch<TRequest, TResponse>(url: string, data: TRequest): Promise<TResponse> {
        return this.postput(url, data, "PATCH");
    }

    private async postput<TRequest, TResponse>(url: string, data: TRequest, method: "POST" | "PUT" | "PATCH"): Promise<TResponse> {

        let response = await fetch(this.host + url, {
            method: method,
            body: JSON.stringify(data),
            headers: new Headers(this.customHeaders)
        });

        let body = await response.json();

        if (response.ok === true) {
            return body;
        }

        return Promise.reject(body);
    }
}


// WEBPACK FOOTER //
// ./ts/Service.ts